import * as React from "react";
import { Link, styled } from "@mui/material";

//region [[ Styles ]]

const ClinicSmallLinkView = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "underline",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "none",
  },
  fontSize: 14,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicSmallLinkProps {
  onClick: () => void;
  children: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicSmallLink = ({ ...props }: ClinicSmallLinkProps) => {
  return (
    <ClinicSmallLinkView color={"primary"} onClick={props.onClick}>
      {props.children}
    </ClinicSmallLinkView>
  );
};
